import { HTTP_REQUEST } from "../../http-config/trac-http-req";

const state = {};

const getters = {};

const actions = {
  GET_BUSINESS_REGISTRATION_TYPES: async function (context, payload) {
    const httpReq = {
      url: `/v1/features?category=BUSINESS_TYPES`,
      method: "GET",
      authRequest: true
    };
    const httpRes = await HTTP_REQUEST(httpReq);
    return httpRes;
  },
  PROCESS_CORPORATE_VERIFICATION: async function (context, {businessId, payload}) {
    const httpReq = {
      url: `/v2/businesses/admin/${businessId}/verify-corporate`,
      method: "POST",
      authRequest: true,
      body: payload
    };
    const httpRes = await HTTP_REQUEST(httpReq);
    return httpRes;
  }
};
const mutations = {};

export default {
  state,
  getters,
  actions,
  mutations,
};
